import React from 'react';
export function InstantAccessSection() {
  const items = [{
    emoji: '📘',
    text: 'I Manuali del Metodo'
  }, {
    emoji: '🤲',
    text: 'Il Manuale delle Firme Artistiche'
  }, {
    emoji: '🗂️',
    text: 'Le Schede Rapide'
  }, {
    emoji: '📓',
    text: 'Registro Allievi & Valutazioni'
  }];
  return <section className="py-20 px-4 bg-[#f2ebe1]" data-id="element-89">
      <div className="max-w-4xl mx-auto text-center" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-91">
          📲 Cosa ricevi immediatamente?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-92">
          {items.map((item, i) => <div key={i} className="bg-white rounded-2xl p-5 flex items-center justify-center gap-3 shadow-sm border border-white/50" data-id="element-93">
              <span className="text-2xl" data-id="element-94">{item.emoji}</span>
              <span className="font-bold text-brand-text" data-id="element-95">{item.text}</span>
            </div>)}
        </div>

        <p className="text-2xl font-serif italic text-brand-green font-bold" data-id="element-96">
          Copri il materiale di tutto l'anno
        </p>
      </div>
    </section>;
}